import React, { useState, useEffect } from 'react';
const ScoreSuccess = (props) => {
    const strokeColor = props.stroke || 'white';
    const strokeFill = props.fill || '#4C6AFF';
    const [id, setId] = useState(`${Math.random()}`);
    useEffect(() => {
        const id = `${Math.random()}`;
        setId(id);
    }, []);
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    delete attribute.fill;
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("circle", { cx: "8", cy: "8", r: "7", fill: strokeFill }),
        React.createElement("path", { d: "M5.2998 8L7.42113 10.1213C7.42113 10.1213 9.74002 7.80242 11.3102 6.23223", stroke: strokeColor, "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
export default ScoreSuccess;
